
	import { Component, Vue} from 'vue-property-decorator';	
	import { SessionManager } from "@/components/utils/utils";

	@Component
	export default class SignOutPage extends Vue {

		public signout(){
			Vue.nextTick().then(() => {            
                SessionManager.logoutAndRedirect(this.$store);
        	});
		}		
	}
